"use client";

import { useState } from "react";

import Image from "next/image";
import { supabaseResponsiveLoader } from "@/lib/utils/supabaseResponsiveLoader";

import styles from "./BaseImageSwitcher.module.css";

type View = "scout" | "wall" | "trap";

type Props = {
  title: string;
  scout?: string | null;
  wall?: string | null;
  trap?: string | null;
};

export default function BaseImageSwitcher({
  title,
  scout,
  wall,
  trap,
}: Props) {
  const initialView: View = scout ? "scout" : wall ? "wall" : "trap";

  const [view, setView] = useState<View>(initialView);

  const currentImage =
    view === "wall" ? wall : view === "trap" ? trap : scout;

  if (!currentImage) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageShell}>
        <div className={styles.imageWrap}>
          <Image
            key={view}
            src={currentImage}
            loader={supabaseResponsiveLoader}
            alt={`${title} ${view} view`}
            fill
            priority
            sizes="(max-width: 767px) 100vw, (max-width: 1023px) 460px, 520px"
            className={styles.image}
          />
        </div>

        <div className={styles.switcher} aria-label="Base image views">
          {scout && (
            <button
              type="button"
              className={styles.button}
              data-active={view === "scout"}
              onClick={() => setView("scout")}
            >
              Scout
            </button>
          )}

          {wall && (
            <button
              type="button"
              className={styles.button}
              data-active={view === "wall"}
              onClick={() => setView("wall")}
            >
              Walls
            </button>
          )}

          {trap && (
            <button
              type="button"
              className={styles.button}
              data-active={view === "trap"}
              onClick={() => setView("trap")}
            >
              Traps
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
